import { EventCodeModel } from './eventcode-model';
import { GuestModel } from './guest-model';
import { GuestGroupModel } from './guestgroup-model';

export class TopicMessageModel {

    constructor(readonly eventCode: string,
                readonly topicKey: string,
                readonly key: string,
                readonly content: string,
                readonly authorId: string,
                readonly creationDate: Date,
                readonly modificationDate: Date) {
    }

}


// WEBPACK FOOTER //
// ./src/app/models/topic-message-model.ts